import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  deleteButton: {
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    '&:hover': {
      borderColor: theme.palette.error.dark,
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.contrastText,
    },
  },
}))

export default useStyles
